import { useState } from 'react'
import { soundManager } from '../../utils/sounds'
import { cyberpunkTheme } from '../../styles/theme'

export default function SoundToggle() {
  const [enabled, setEnabled] = useState(() => soundManager.isEnabled())
  const t = cyberpunkTheme.colors

  const toggle = () => {
    const newState = soundManager.toggle()
    setEnabled(newState)
    // Play a test click when turning ON so user gets instant feedback
    if (newState) soundManager.playClick()
  }

  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={enabled ? 'Mute sound effects' : 'Unmute sound effects'}
      title={enabled ? 'SFX ON — click to mute' : 'SFX OFF — click to enable'}
      style={{
        position: 'fixed',
        bottom: 'max(0.875rem, env(safe-area-inset-bottom, 0.875rem))',
        right: 'max(0.875rem, env(safe-area-inset-right, 0.875rem))',
        width: '40px',
        height: '40px',
        borderRadius: '4px',
        background: enabled ? 'rgba(0, 245, 255, 0.07)' : 'rgba(13,13,26,0.85)',
        border: `2px solid ${enabled ? t.primary : t.border.default}`,
        color: enabled ? t.primary : t.text.muted,
        fontSize: '1rem',
        lineHeight: 1,
        cursor: 'pointer',
        boxShadow: enabled ? `0 0 8px rgba(0,245,255,0.25)` : 'none',
        transition: 'all 0.2s ease',
        zIndex: 1100,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backdropFilter: 'blur(4px)',
        WebkitBackdropFilter: 'blur(4px)',
        flexShrink: 0,
      }}
    >
      {enabled ? '♪' : '✕'}
    </button>
  )
}
